<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-8 mt-2 mt-8 sm:-mt-px mb-8">
        <entitlement-period-has
            v-model="has_entitlement_period"
            :read_only="read_only"
        />

        <div v-if="has_entitlement_period">
            <entitlement-period-date
                :commercial="commercial"
                :entitlement_extend_days="entitlement_extend_days"
                :read_only="read_only"
                @updated="updatedEntitlementDate"
            />

            <entitlement-period-zoning
                :commercial="commercial"
                :read_only="read_only"
            />

            <entitlement-period-extend
                v-model="entitlement_extend_days"
                :commercial="commercial"
                :entitlement_date="entitlement_date"
                :read_only="read_only"
            />
        </div>
    </div>
</template>

<script>
import EntitlementPeriodHas from './entitlement-period-has.vue';
import EntitlementPeriodZoning from './entitlement-period-zoning.vue';
import EntitlementPeriodDate from './entitlement-period-date.vue';
import EntitlementPeriodExtend from './entitlement-period-extend.vue';

export default {
    components: {
        EntitlementPeriodHas,
        EntitlementPeriodZoning,
        EntitlementPeriodDate,
        EntitlementPeriodExtend,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            has_entitlement_period: this.commercial.has_entitlement_period,
            entitlement_date: this.commercial.entitlement_date,
            entitlement_extend_days: this.commercial.entitlement_extend_days,
        }
    },

    methods: {
        updatedEntitlementDate(value) {
            this.entitlement_date = value;
        },
        updatedHasEntitlementPeriod(value) {
            this.has_entitlement_period = value;
        },
    },
}
</script>
